module finadai.filters {
  export var NAME = 'finadai.filters';
  function yesnoFilter(){
    return (input) => {
      return input ? 'Si' : 'No'
    }
  }
  function sumFilter(){
    return (input, index) => {
      if(!angular.isArray(input)) return 0;
      return input.reduce((acum, item) => acum + item[index], 0);
    }
  }
  function nl2brFilter() {
    return function(data) {
      if (!data) return data;
      return data.replace(/\n\r?/g, '<br />');
    };
  }
  function commasFilter() {
    return function(data, index) {
      return data.map(x => x[index]).join(', ');
    };
  }
  function metaFilter($filter) {
    return function(data, key, separator) {
      separator = separator || '<br />'
      var matches = data.filter(x => x.key == key);
      if(matches.length > 0){
        return matches[0].value.map(x => $filter('date')(x._date, 'dd.MMM.yyyy')).join(separator)
      }
      return ''
    };
  }
  function momentDateFilter(){
    return (input, format = 'D [de] MMMM [de] YYYY') => {
      if (input == "No Proporcionada") return input;
      if (!input) return input;
      return moment(input).format(format);
    }
  }
  function direccionFilter(){
    return (input: models.proxy.Customer) => {
      if (!input) return '';
      return `${input.CalleNumero}  ${input.Colonia}, ${input.Municipio}, ${input.Estado}, CP ${input.CodigoPostal}`;
    }
  }
  function adeudoCreditoFilter() {
    return (input: models.proxy.Saldo) => {
      if (!input) return 0;
      return parseFloat(input.Capital) + parseFloat(input.InteresesMoratorios) + parseFloat(input.InteresesOrdinarios) + parseFloat(input.Accesorios);
    }
  }
  export function run() {
    var filters = angular.module(NAME, []);
    filters.filter('yesno', yesnoFilter);
    filters.filter('sum', sumFilter);
    filters.filter('nl2br', nl2brFilter);
    filters.filter('commas', commasFilter);
    filters.filter('meta', metaFilter);
    filters.filter('momentDate', momentDateFilter);
    filters.filter('direccion', direccionFilter);
    filters.filter('adeudoCredito', adeudoCreditoFilter);
  }
}
finadai.filters.run();